import { getStoryblokRequest } from '@crunchyroll/cr-static-shared-components'

const getAllStoryblokRequests = (allRequests, lang) => {
  if (!allRequests) return false

  return (
    allRequests &&
    allRequests.endpoints &&
    allRequests.endpoints.map(async ({ url, params }) => {
      const request = await getStoryblokRequest(url, params, lang)
      return request()
    })
  )
}

export { getAllStoryblokRequests }
